export function normalizeLanguage(lang) {
	if (!lang) return null;
	const base = String(lang).toLowerCase().split("-")[0];
	if (base === "en") return "en";
	if (base === "de") return "de";
	return base;
}
